
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 6.5c-.331.005-.66.058-.976.156.146.258.224.548.226.844A1.75 1.75 0 017.5 9.25a1.731 1.731 0 01-.844-.226A3.491 3.491 0 1010 6.5zm8.891 3.044C17.197 6.237 13.841 4 10 4 6.158 4 2.802 6.239 1.109 9.544a1.011 1.011 0 000 .912C2.803 13.763 6.159 16 10 16c3.842 0 7.198-2.239 8.891-5.544a1.01 1.01 0 000-.912zM10 14.5c-3.083 0-5.91-1.719-7.435-4.5C4.09 7.219 6.917 5.5 10 5.5c3.083 0 5.91 1.719 7.435 4.5-1.526 2.781-4.352 4.5-7.435 4.5z"}})])
          )
        }
      }
    